<template>
  <container>
    <div class="subpage-list" v-if="cityDetails">
      <div class="text-center mb-35">
        <div class="result-bracket__title">
          <span class="result-bracket__count">{{ cityDetails.districts.length }}</span> İlçe Bulunuyor!
        </div>
      </div>
      <div class="flex-row">
        <router-link to="#" class="subpage-list__item"
                     v-for="district in cityDetails.districts"
                     :key="district.id">
          <DistrictCard :district="district" :city="cityDetails.slug"/>
        </router-link>
      </div>
    </div>
  </container>
</template>

<script>
import DistrictCard from '@/components/DistrictCard'
import { mapGetters } from 'vuex'
export default {
  name: 'CityDetailDistrict',
  components: {
    DistrictCard
  },
  computed: {
    ...mapGetters(['cityDetails'])
  }
}
</script>

<style scoped>

</style>
